import { render, staticRenderFns } from "./courseAndService.vue?vue&type=template&id=926d30aa&scoped=true&"
import script from "./courseAndService.vue?vue&type=script&lang=js&"
export * from "./courseAndService.vue?vue&type=script&lang=js&"
import style0 from "./courseAndService.vue?vue&type=style&index=0&id=926d30aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926d30aa",
  null
  
)

export default component.exports